var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_3210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.880168 14.09L4.75017 18C4.84313 18.0938 4.95373 18.1681 5.07559 18.2189C5.19745 18.2697 5.32816 18.2958 5.46017 18.2958C5.59218 18.2958 5.72289 18.2697 5.84474 18.2189C5.9666 18.1681 6.0772 18.0938 6.17017 18C6.2639 17.9071 6.33829 17.7965 6.38906 17.6746C6.43983 17.5527 6.46597 17.422 6.46597 17.29C6.46597 17.158 6.43983 17.0273 6.38906 16.9054C6.33829 16.7836 6.2639 16.673 6.17017 16.58L2.61017 13H23.0002C23.2654 13 23.5197 12.8947 23.7073 12.7071C23.8948 12.5196 24.0002 12.2652 24.0002 12C24.0002 11.7348 23.8948 11.4805 23.7073 11.2929C23.5197 11.1054 23.2654 11 23.0002 11H2.55017L6.17017 7.38002C6.34746 7.19405 6.44636 6.94696 6.44636 6.69002C6.44636 6.43308 6.34746 6.186 6.17017 6.00002C6.0772 5.90629 5.9666 5.8319 5.84474 5.78113C5.72289 5.73036 5.59218 5.70422 5.46017 5.70422C5.32816 5.70422 5.19745 5.73036 5.07559 5.78113C4.95373 5.8319 4.84313 5.90629 4.75017 6.00002L0.880168 9.85002C0.318366 10.4125 0.00280762 11.175 0.00280762 11.97C0.00280762 12.765 0.318366 13.5275 0.880168 14.09Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_3210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.21c5865e4bf5a40026fcc3bccf93dcf7.svg";
export { ForwardRef as ReactComponent };